import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogTitleContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: theme?.aboutPopup?.headerBackgroundColor,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  dialogTitle: {
    color: theme?.aboutPopup?.headerTextColor,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0.5),
    color: theme?.aboutPopup?.closeIconColor,
  },
  labelTxt: {
    width: '42%',
    color: theme?.aboutPopup?.secondaryTextColor,
  },
  valueTxt: {
    width: '58%',
    color: theme?.aboutPopup?.primaryTextColor,
  },
}));

export default useStyles;
